import {API_BASE_URL} from "@/lib/config";
import {RepertoireEntry} from "@/types/repertoire";
import { PracticeSession } from "@/types/practice-session";
import {Work} from "@/types/work";
import {Composer} from "@/types/composer";
import {RepertoireStatus} from "@/types/enums";
import {Period} from "@/types/period";

export async function getRepertoire(): Promise<RepertoireEntry[]> {
    const res = await fetch(`${API_BASE_URL}/api/repertoire`, {
        cache: "no-store",
    });

    if (!res.ok) {
        throw new Error("Failed to fetch repertoire");
    }

    return res.json();
}

export async function createRepertoire(
    workId: number
) {
    const res = await fetch(`${API_BASE_URL}/api/repertoire`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({work_id: workId}),
    });

    if (!res.ok) {
        const error = await res.text();
        throw new Error(error);
    }

    return res.json();
}

export async function patchRepertoire(id: number, data: {
    work_id?: number;
    status?: RepertoireStatus;
    date_added?: string;
}) {
    const res = await fetch(`${API_BASE_URL}/api/repertoire/${id}`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });

    if (!res.ok) {
        const error = await res.text();
        throw new Error(error);
    }

    return res.json();
}

export async function getRepertoirePiece(id: number): Promise<RepertoireEntry> {
    const res = await fetch(`${API_BASE_URL}/api/repertoire/${id}`, {
        cache: "no-store",
    });

    if (!res.ok) {
        throw new Error("Failed to fetch piece");
    }

    return res.json();
}

export async function createPracticeSession(data: {
    date: string;
    minutes: number;
    repertoire_id: number;
    reflection: string;
}) {
    const res = await fetch(`${API_BASE_URL}/api/practice_session`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });

    if (!res.ok) {
        const error = await res.text();
        throw new Error(error);
    }

    return res.json();
}

export async function getPracticeSessions(): Promise<PracticeSession[]> {
    const res = await fetch(`${API_BASE_URL}/api/practice_session`, {
        cache: "no-store",
    });

    if (!res.ok) {
        throw new Error("Failed to fetch practice sessions");
    }

    return res.json();
}

export async function getPracticeSession(id: string): Promise<PracticeSession> {
    const res = await fetch(`${API_BASE_URL}/api/practice_session/${id}`, {
        cache: "no-store",
    });

    if (!res.ok) {
        throw new Error("Failed to fetch session");
    }

    return res.json();
}

export async function getWorks(): Promise<Work[]> {
    const res = await fetch(`${API_BASE_URL}/api/work`, {
        cache: "no-store",
    });

    if (!res.ok) {
        throw new Error("Failed to fetch repertoire");
    }

    return res.json();
}

export async function getWork(id: string): Promise<Work> {
    const res = await fetch(`${API_BASE_URL}/api/work/${id}`, {
        cache: "no-store",
    });

    if (!res.ok) {
        throw new Error("Failed to fetch piece");
    }

    return res.json();
}


export async function getComposers(): Promise<Composer[]> {
    const res = await fetch(`${API_BASE_URL}/api/composer`, {
        cache: "no-store",
    });

    if (!res.ok) {
        throw new Error("Failed to fetch repertoire");
    }

    return res.json();
}

export async function getComposer(id: string): Promise<Composer> {
    const res = await fetch(`${API_BASE_URL}/api/composer/${id}`, {
        cache: "no-store",
    });

    if (!res.ok) {
        throw new Error("Failed to fetch piece");
    }

    return res.json();
}

export async function getPeriods(): Promise<Period[]> {
    const res = await fetch(`${API_BASE_URL}/api/period`, {
        cache: "no-store",
    });

    if (!res.ok) {
        throw new Error("Failed to fetch repertoire");
    }

    return res.json();
}

